export type TranscriptDeltaTiming = {
  elapsedMs?: number;
  receivedAtMs: number;
};

export const TRANSCRIPT_PARAGRAPH_PAUSE_MS = 1_200;

export function appendTranscriptDelta(
  current: string,
  delta: string,
  maxCharacters = 4_000,
  startNewParagraph = false,
): string {
  const next = startNewParagraph && current.trim() && delta.trim()
    ? `${current.trimEnd()}\n\n${delta.trimStart()}`
    : `${current}${delta}`;
  return next.length <= maxCharacters ? next : next.slice(-maxCharacters);
}

export function shouldStartTranscriptParagraph(
  previous: TranscriptDeltaTiming | null,
  current: TranscriptDeltaTiming,
  pauseMs = TRANSCRIPT_PARAGRAPH_PAUSE_MS,
): boolean {
  if (!previous) return false;
  if (
    previous.elapsedMs !== undefined &&
    current.elapsedMs !== undefined &&
    current.elapsedMs >= previous.elapsedMs
  ) {
    return current.elapsedMs - previous.elapsedMs >= pauseMs;
  }
  return current.receivedAtMs - previous.receivedAtMs >= pauseMs;
}
